// extracted by mini-css-extract-plugin
export default {"RotatedImageList":"UG6Bp","MainImage":"_FzSZ","ThumbnailImage":"n6Frn"};